import React from 'react';

const StoryMode = () => (
  <div className="container">
    <h1 className='scroll-m-20 text-center text-4xl font-extrabold tracking-tight text-balance'>Story Mode page</h1>
  </div>
);

export default StoryMode;
